export const UNIT_STRINGS = {
  CREDIT: 'C',
  POINT: 'P',
  WON: '원',
  GRAM: 'g',
  KILOGRAM: 'kg',
} as const;
